import { getApiOrigin } from '@hungryroot/rest';

export const getFilteredRecipes = (params) => {
  // This is a function that uses the _new_ get_pairing backend API
  return new Promise((resolve, reject) => {
    let options = {
      type: 'GET',
      url: `${getApiOrigin()}/api/filter_pairings/`,
      contentType: 'application/json',
      dataType: 'json',
      data: params,
    };
    let xhr = $.ajax(options);
    xhr.done((newData) => {
      resolve(newData);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        `Got ${textStatus} When trying to fetch filtered pairings. Error: ${errorThrown}`
      );
    });
  });
};

export const getFilteredProducts = (params) => {
  // This is a function that uses the _new_ get_pairing backend API
  return new Promise((resolve, reject) => {
    let options = {
      type: 'GET',
      url: `${getApiOrigin()}/api/filter_products/`,
      contentType: 'application/json',
      dataType: 'json',
      data: params,
    };
    let xhr = $.ajax(options);
    xhr.done((newData) => {
      resolve(newData);
    });
    xhr.fail((jqXHR, textStatus, errorThrown) => {
      reject(
        `Got ${textStatus} When trying to fetch filtered pairings. Error: ${errorThrown}`
      );
    });
  });
};
